import React from 'react';
import { StyledBox } from './styles';
import { BoxProps } from '@mui/material';

export interface HorizontalScrollerProps {
  className?: string;
  children: React.ReactChild | React.ReactChild[];
  white?: boolean;
}

const HorizontalScroller = ({
  className,
  children,
  white,
  ...other
}: HorizontalScrollerProps & BoxProps) => {
  return (
    <StyledBox white={white} className={className} {...other} component="ul">
      {children}
    </StyledBox>
  );
};

export default HorizontalScroller;
